import styled from 'styled-components';

import { Image, Text } from '@pega/cosmos-react-core';

export const Paragraph = styled(Text)`
  width: 30ch;
`;

export const StyledImage = styled(Image)`
  max-width: 6rem;
`;
